import { useCallback, useEffect, useState } from 'react'
import { Admission, Adresses, CandidateInfo, Education, Main, Medicine, Parents, Priveleges, Schedule } from './ModalTabs'
import Modal from 'react-responsive-modal'
import { candidatesModalModes } from '../../assets/const'
import styles from './styles.module.scss'
import userPhoto from '../../assets/images/user_photo.png'
import cn from 'classnames'
import { CandidatesContext } from '../../utils/context'
import Confirmation from '../../components/Confirmation/Confirmation'

export default function ModalComponent({ candidateId, isOpen, closeModal, addMode }) {

    const [mode, setMode] = useState('main')
    const [confirmClose, setConfirmClose] = useState(false)

    useEffect(() => {
        if (!isOpen) setMode('main')
    }, [isOpen])
    const handleClose = useCallback(() => setConfirmClose(true), [])
    const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
    const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

    const renderLi = ({ name, value, icon }) => {
        const selected = value === mode
        return (
            <li
                onClick={() => setMode(value)}
                className={cn(styles.modalMenuItem, {
                    [styles.selectedMenuItem]: selected
                })}
            >
                {icon()}
                {name}
            </li>
        )
    }

    const renderTab = () => {
        switch (mode) {
            case 'main': return <Main />
            case 'adresses': return <Adresses />
            case 'priveleges': return <Priveleges />
            case 'parents': return <Parents />
            case 'admission': return <Admission />
            case 'medicine': return <Medicine />
            case 'education': return <Education />
            case 'candidateInfo': return <CandidateInfo />
            case 'schedule': return <Schedule />
            default: return
        }
    }

    return (
        <CandidatesContext.Provider value={{ candidateId, closeModal: handleClose, addMode }}>
            <Modal
                open={isOpen}
                onClose={handleClose}
                classNames={{ modal: styles.modalMain }}
                closeOnOverlayClick={true}
                closeOnEsc={true}
                showCloseIcon={false}
                animationDuration={1}
            >
                <div className={styles.modalContent}>
                    <div className={styles.modalMenu}>
                        <img src={userPhoto} alt='o_O' />
                        <ul>{candidatesModalModes.map(renderLi)}</ul>
                    </div>
                    {renderTab()}
                </div>
                {confirmClose && (
                    <Confirmation
                        title="Закрыть без сохранения изменений?"
                        acceptConfirmation={acceptConfirmation}
                        rejectConfirmation={rejectConfirmation}
                    />
                )}
            </Modal>
        </CandidatesContext.Provider>
    )
}